import React, { FC, CSSProperties } from 'react'
import s from './LoadingSpinner.module.sass'

import IconLoading from '@icons/icon-booking-loading.svg'
import { ErrorBoundary } from '../../../lib/components/ErrorBoundary'

interface Props {
  loading: boolean
  // Вот этим пропом можно просто сверху в css-е где надо позволить назначить цвет для крутилки
  // По дефолту красная, т.к. уже много где юзается, можно от этого отказаться и открутить этот флаг
  iconColor?: CSSProperties['color']
  className?: string
  size?: number
}

const LoadingSpinner: FC<Props & React.DetailedHTMLProps<React.HTMLAttributes<HTMLDivElement>, HTMLDivElement>> = ({
  loading,
  iconColor = '#FF3118',
  size,
  className = '',
  ...props
}) => {
  return (
    <ErrorBoundary>
      <div className={`${s.wrapper} ${className}`} data-visible={loading} {...props}>
        <IconLoading
          className={s.spinner}
          style={{
            width: size ? `${size}px` : undefined,
            height: size ? `${size}px` : undefined,
            color: iconColor,
          }}
        />
      </div>
    </ErrorBoundary>
  )
}

export default LoadingSpinner
